// We want to quickly use actions without depending on dispatch
// If we implement SSR we need to modify this based on request context

let dispatch: Function;
export const setDispatch = (f: Function) => {
  dispatch = f;
};
export const wrapDispatch = <T>(actions: T): T => {
  // @ts-ignore
  Object.entries(actions).forEach(([k, v]) => {
    // @ts-ignore
    actions[k] = (...args) => {
      // @ts-ignore
      const a = v(...args);
      dispatch(a);
      return a;
    };
  });
  return actions;
};
